import { Link } from "wouter";
import { 
  Phone, 
  Mail, 
  MapPin, 
  Facebook, 
  X, 
  Linkedin, 
  Instagram 
} from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-slate-800 text-white">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Mission */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded-lg bg-primary-600 flex items-center justify-center shadow-md p-1">
                <svg viewBox="0 0 24 24" className="h-7 w-7" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7zm2.85 11.1l-.85.6V16h-4v-2.3l-.85-.6A4.997 4.997 0 0 1 7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.63-.8 3.16-2.15 4.1z" 
                    fill="#FACC15" />
                </svg>
              </div>
              <span className="text-xl font-bold text-white">StaffAbility</span>
            </div>
            <p className="mt-4 text-sm text-slate-300">
              Building futures, one second chance at a time. We help individuals overcome significant life barriers through employment opportunities and comprehensive support.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold text-slate-400 tracking-wider uppercase">Quick Links</h3>
            <ul className="mt-4 space-y-4">
              <li>
                <Link href="/">
                  <span className="text-base text-slate-300 hover:text-white cursor-pointer">Home</span>
                </Link>
              </li>
              <li>
                <Link href="/about">
                  <span className="text-base text-slate-300 hover:text-white cursor-pointer">About Us</span>
                </Link>
              </li>
              <li>
                <Link href="/programs">
                  <span className="text-base text-slate-300 hover:text-white cursor-pointer">Programs</span>
                </Link>
              </li>
              <li>
                <Link href="/success-stories">
                  <span className="text-base text-slate-300 hover:text-white cursor-pointer">Success Stories</span>
                </Link>
              </li>
              <li>
                <Link href="/contact">
                  <span className="text-base text-slate-300 hover:text-white cursor-pointer">Contact</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Get Involved */}
          <div>
            <h3 className="text-sm font-semibold text-slate-400 tracking-wider uppercase">Get Involved</h3>
            <ul className="mt-4 space-y-4">
              <li>
                <Link href="/get-help">
                  <span className="text-base text-slate-300 hover:text-white cursor-pointer">Get Help</span>
                </Link>
              </li>
              <li>
                <Link href="/hire-from-us">
                  <span className="text-base text-slate-300 hover:text-white cursor-pointer">Hire From Us</span>
                </Link>
              </li>
              <li>
                <Link href="/get-involved">
                  <span className="text-base text-slate-300 hover:text-white cursor-pointer">Donate</span>
                </Link>
              </li>
              <li>
                <Link href="/get-involved">
                  <span className="text-base text-slate-300 hover:text-white cursor-pointer">Volunteer</span>
                </Link>
              </li>
              <li>
                <Link href="/get-involved">
                  <span className="text-base text-slate-300 hover:text-white cursor-pointer">Partner With Us</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-sm font-semibold text-slate-400 tracking-wider uppercase">Contact Us</h3>
            <ul className="mt-4 space-y-4">
              <li className="flex">
                <Phone className="h-6 w-6 text-slate-400" />
                <span className="ml-3 text-base text-slate-300">(319) 493-7201</span>
              </li>
              <li className="flex">
                <Mail className="h-6 w-6 text-slate-400" />
                <span className="ml-3 text-base text-slate-300">contact@staffability.org</span>
              </li>
              <li className="flex">
                <MapPin className="h-6 w-6 text-slate-400" />
                <span className="ml-3 text-base text-slate-300">315 E 5th St. STE 202<br />Waterloo, IA 50703</span>
              </li>
              <li className="flex items-center space-x-4 mt-4">
                <a href="https://facebook.com" className="text-slate-400 hover:text-primary-500" target="_blank" rel="noopener noreferrer">
                  <Facebook className="h-5 w-5" />
                  <span className="sr-only">Facebook</span>
                </a>
                <a href="https://x.com" className="text-slate-400 hover:text-primary-500" target="_blank" rel="noopener noreferrer">
                  <X className="h-5 w-5" />
                  <span className="sr-only">X (Twitter)</span>
                </a>
                <a href="https://linkedin.com" className="text-slate-400 hover:text-primary-500" target="_blank" rel="noopener noreferrer">
                  <Linkedin className="h-5 w-5" />
                  <span className="sr-only">LinkedIn</span>
                </a>
                <a href="https://instagram.com" className="text-slate-400 hover:text-primary-500" target="_blank" rel="noopener noreferrer">
                  <Instagram className="h-5 w-5" />
                  <span className="sr-only">Instagram</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-slate-700 pt-8">
          <div className="text-base text-slate-400 text-center">
            <p className="mb-2">
              &copy; {new Date().getFullYear()} StaffAbility. All rights reserved.
            </p>
            <p className="text-sm">
              Built by <a href="https://karlis.works" target="_blank" rel="noopener noreferrer" className="text-primary-400 hover:text-primary-300">KRB</a> 😎
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
